<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <!-- Junior Training -->
            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Junior Training</h2>
                        </div>

                        <div class="col-12 col-lg-9">
                            <!-- Text -->
                            <p class="h5">We run training sessions all year round. If you want to join any of our
                                          sessions please <a href="mailto:cricket@ealingtcc.com">register your interest by contacting us
                                                                                           </a>
                                          or just drop in and say Hi. Our coaches are fully qualified by the ECB and DBS
                                          checked. We put an emphasis on creating a safe and fun environment for kids of
                                          all abilities to learn and grow as individuals.</p>

                            <ul class="list-group list-group-flush mt-4">
                                <li v-for="train in training"
                                    v-bind:key="train._id"
                                    class="list-group-item">
                                    <h5 class="mb-1">{{train.title}}</h5>
                                    <p class="h6 text-muted">{{train.where}}</p>
                                    <p class="mt-3">{{train.description}}</p>
                                </li>
                            </ul>

                        </div>

                    </div>

                </div>

            </div>

            <!-- Our Coaches -->
            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Our Coaches</h2>
                        </div>

                        <div class="col-12 col-lg-9">
                            <!-- Text -->
                            <p class="h5">We are committed to providing the best possible coaching for your 
                            child. Our coaches are all ECB qualified and between them have 
                            many years of experience. They aim to provide a safe and fun 
                            atmosphere to enable your child to learn the game and make 
                            lifelong friends.</p>

                            <!-- <ul class="list-group list-group-flush mt-4">
                                <li v-for="(coach, index) in getCoaches" :key="index" class="list-group-item">
                                    <h5 class="has-icon-left"><i class="material-icons">face</i> {{ coach.name }}</h5>
                                    <p class="">{{ coach.experience }}</p>
                                </li>
                            </ul> -->

                            <p></p>

                        </div>



                    </div> <!--row-->

                </div>

            </div>


        </div>

    </div>
</template>
<script>
    import {fetchTraining} from "@/services/api";

    export default {
        data() {
            return {
                training: []
            }
        },
        computed: {
            getCoaches(){
                return [
                    { name:'Richard Langa', experience: 'ECB Level 3' },
                    { name:'Muhammad Qaiser', experience: 'ECB Level 2' },
                    { name:'Fahim Bahrami', experience: 'ECB Level 2' },
                    { name:'Farid Butt', experience: 'ECB Level 2' },
                    { name:'Joss Bell', experience: 'ECB Level 2' },
                    { name:'Shahbaz Meer', experience: 'ECB Level 2' },
                    { name:'Anjum Zaheer', experience: 'ECB Level 1' },
                ]
            }
        },
        created() {
            this.fetchList();
        },
        methods: {
            fetchList() {
                fetchTraining()
                    .then(response => {
                        this.training = response;
                    })
            },
        }
    }
</script>
